
/**
 * VR登录
 * @param id   { String }  展商id
 * @param that { Object }  Vue实例
 * @returns Vr登录需要的数据
 */
export function VRLogin(id,that) {
     let vrData = new Object();
     const TIME =parseInt(new Date().getTime() / 1000);
     const ID = id;
     var APPID = 'vrchinamin_apiaccount!@#';
     const SIGN = that.$md5(TIME + APPID + ID);
     vrData.hzExhibitor_id = ID;
     vrData.sign = SIGN;
     vrData.time = TIME;   
    return vrData;
}

